import { QueryParamDropdownListT } from "./useQueryParamDropdown";

function getQueryParamsCount(state: QueryParamDropdownListT) {
  return Object.values(state).reduce((count, qps) => count + qps.length, 0);
}
export default getQueryParamsCount;
